export enum QuestionType {
  MULTIPLE_SELECTION = 1,
  NUMBER = 2,
  TEXT = 3,
  SINGLE_SELECTION = 4,
}

export type Question = {
  id: string;
  options: Option[];
  correctAnswerIndex?: number;
  question: string;
  type: QuestionType;

  image?: string;
  imageURL: string;
  placeholder?: string;
  rightAddon?: string;
  requires?: number;
  multipleLines?: boolean;
};

export type Option = {
  description: string;
  id: string;
};

export type QuestionnaireResult = {
  createdAt: string;
  answers: Answer[];
  userId: string;
};
export type Answer = {
  questionId: string;
  answer: string;
};
